export class ViewModelRespostaTemporaria {
  idPessoa: number;
  idPlano: number;
  numeroPergunta: number;
  numeroResposta: number;
  dataResposta: Date;
}
